import {
  SET_BREADCRUMB,
  SET_CHANGED,
  SET_EXPAND_CHART,
  SET_GLOBAL_SETTING,
  SHOW_WARRING_CHANGE_MESSAGE
} from "../actions/types"
import StateLoader from "../StateLoader"
const stateLoader = new StateLoader()

const AppReducer = (
  state = stateLoader.loadStateByReducer("appReducer"),
  action
) => {
  switch (action.type) {
    case SET_CHANGED:
      return {
        ...state,
        changed: action.changed,
        callback: action.callback
      }
    case SHOW_WARRING_CHANGE_MESSAGE:
      return {
        ...state,
        showWarringChangeMessage: action.showWarringChangeMessage
      }
    case SET_BREADCRUMB:
      return {
        ...state,
        breadcrumb: action.breadcrumb
      }
    case SET_EXPAND_CHART:
      return {
        ...state,
        expandChart: action.expandChart
      }
    case SET_GLOBAL_SETTING:
      return {
        ...state,
        globalSetting : action.globalSetting
      }
    default:
      return state
  }
}

export default AppReducer
